(function ($) {
  'use strict';

  /**
   * Atreemo API Form
   */

  var $from_category_select = $( '.js-atreemo-form-cat' );
  var $form_template_container = $('#js-atreemo-tmpl-form-container');
  var default_form_category = '';

  // Init Form
  // - Open default category form group
  if ( $from_category_select.length ) {
    default_form_category = $from_category_select.val();

    if ( default_form_category ) {
      var $default_template = get_atreemo_form_template_by_id( default_form_category );

      if ( $default_template.length ) {
        $form_template_container.append( $default_template[0].content.cloneNode( true ) );
      }
    }
  }


  // Category Select
  // - Change displayed form fields when selecting category
  $from_category_select.on('change', function () {
    var $this = $(this);
    var this_id = $this.val();
    var $this_template = get_atreemo_form_template_by_id( this_id );

    if ( $this_template.length ) {
      $form_template_container.empty();
      $form_template_container.append( $this_template[0].content.cloneNode( true ) );
      // Update live region
      update_category_live_region( this_id );
    }
  });


  // helper - Get form template
  function get_atreemo_form_template_by_id( id ) {
    var template_id = 'tmpl-form-' + id;
    var $template = $( '#' + template_id );
    return $template;
  }


  // a11y - Update category live rgion
  function update_category_live_region( category_id ) {
    var $category_live_region = $('.js-form-category-live-region');
    var live_message = $category_live_region.data( 'live-message' );
    var form_title = $from_category_select
      .find( 'option[value="' + category_id + '"]' )
      .text();
    console.log( live_message + ': ' + form_title.trim() );
    $category_live_region.text( live_message + ': ' + form_title.trim() );
  }

})(jQuery);


(function ($) {
  'use strict';

  /**
   * Update select options on change
   * - Uses data attrs from the API to
   *   set the type, operator, & rule set.
   */

  // init
  $(document).ready( atreemo_update_select_options );

  // Update select options whenever a select is changed
  $('body').on( 'change', '.js-atreemo-form select', atreemo_update_select_options );

  // Toggle select options based on the els "choice rules"
  function atreemo_update_select_options() {
    var $options = $( '.js-atreemo-form select' ).find( 'option' );

    $options.each(function () {
      var $this = $(this);
      var rule_type = $this.data( 'choice-rule-type' );
      var rule_operator = $this.data( 'choice-rule-operator' );
      var rule_sets = $this.data( 'choice-rule-sets' );

      /**
       * Rule Set Validation
       */

      var rule_validation = [];

      if ( rule_sets ) {
        rule_sets.forEach(function ( rule ) {
          var is_validated = false;

          // Basic Toggle
          // - Some option els use a basic on/off toggle: `["1=1"]`
          if ( rule === '1=1' ) {
            is_validated = true;
          }

          /**
           * Select Value Rule Checks
           * - Toggles option els based on the value of another form el.
           */

          // Complex Rule Checks
          var needle = new RegExp( /\[(.*?)\]/ ).exec( rule );
          var haystack = new RegExp( /\((.*?)\)/ ).exec( rule );

          if ( needle && haystack ) {
            var matched_needle = needle[1];
            var matched_haystack = haystack[1].split( ',' );
            var $needle = $( '#q' + matched_needle );
            var is_matched = ( matched_haystack.indexOf( $needle.val() ) !== -1 );

            // Toggle - Show
            if ( is_matched ) {
              is_validated = true;
            }
          }

          rule_validation.push( is_validated );
        });
      }

      // Validation Check
      // - A single 'or' condition has passed
      // - All 'and' conditions passed
      var is_valid = ( rule_operator === 'OR' && rule_validation.includes( true ) )
        || ( rule_operator === 'AND' && ! rule_validation.includes( false ) );

      // Hide Condition
      // - Show by default
      // - Hide if rules are passed
      if ( rule_type === 'Hide' ) {
        // For 'hide', show by default.
        $this.prop( 'hidden', false );
        $this.prop( 'disabled', false );

        // Hide if rules pass
        if ( is_valid ) {
          $this.prop( 'hidden', true );
          $this.prop( 'disabled', true );
        }
      }

      // Show Condition
      // - Hide by default
      // - Show if rules are passed
      if ( rule_type === 'Show' ) {
        // For 'Show' rules, hide by default
        $this.prop( 'hidden', true );
        $this.prop( 'disabled', true );

        // Show if rules pass
        if ( is_valid ) {
          $this.prop( 'hidden', false );
          $this.prop( 'disabled', false );
        }
      }

      // // Hide - 'or' condition
      // // - Hide if _any_ rules pass
      // if ( rule_type === 'Hide'
      //   && rule_operator === 'OR'
      //   && rule_validation.includes( true ) ) {
      //   $this.prop( 'hidden', true );
      //   $this.prop( 'disabled', true );
      // }

      // // Hide - 'and' condition
      // // - Hide if _all_ rules passed
      // if ( rule_type === 'Hide'
      //   && rule_operator === 'AND'
      //   && ! rule_validation.includes( false ) ) {
      //   $this.prop( 'hidden', true );
      //   $this.prop( 'disabled', true );
      // }

      // // Show - 'or' condition
      // // - Show if _any_ rules pass
      // if ( rule_type === 'Show'
      //   &&  ) {
      //   $this.prop( 'hidden', false );
      //   $this.prop( 'disabled', false );
      // }

      // // Show - 'and' condition
      // // - Show if _all_ rules pass
      // if ( rule_type === 'Show'
      //   &&  ) {
      //   $this.prop( 'hidden', false );
      //   $this.prop( 'disabled', false );
      // }

    });
  }

})(jQuery);


(function ($) {
  'use strict';

  /**
   * Atreemo Form Submission
   *
   * Handles collecting fields, base64-encoding file uploads,
   * executing reCAPTCHA v3, and sending the AJAX submission.
   * Requires atreemoFormData to be localized by the shortcode PHP.
   */

  if ( typeof atreemoFormData === 'undefined' ) {
    return;
  }

  var site_key          = atreemoFormData.recaptcha_site_key;
  var $form             = $( '#fiveguys-feedback-form' );
  var $submit_btn       = $form.find( '.js-atreemo-submit-btn' );
  var $error_container  = $form.find( '.js-atreemo-form-error' );
  var $success_el       = $( '.js-atreemo-form-success' );
  var submit_label      = $submit_btn.text();
  var msg_submitting    = $form.data( 'message-submitting' ) || 'Submitting…';
  var msg_error_default = $form.data( 'message-error' ) || 'There was an error submitting the form. Please try again.';

  // File size guard — warn and clear if > 2MB
  $form.on( 'change', 'input[type="file"]', function () {
    var file   = this.files[0];
    var max_mb = 2 * 1024 * 1024;

    if ( file && file.size > max_mb ) {
      alert( 'File must be under 2MB. Please choose a smaller file.' );
      this.value = '';
    }
  });

  // Intercept submit
  $form.on( 'submit', function (e) {
    e.preventDefault();

    // Parsley validation — abort if invalid
    if ( ! $form.parsley().isValid() ) {
      $form.parsley().validate();
      return;
    }

    collect_and_submit();
  });


  // ---- Field collection ----

  function collect_and_submit() {
    var fields        = [];
    var file_promises = [];

    var $inputs = $form.find( 'input[name], select[name], textarea[name]' )
      .not( '[disabled]' );

    $inputs.each( function () {
      var $el         = $( this );
      var field_name  = $el.attr( 'name' );
      var input_type  = ( $el.attr( 'type' ) || '' ).toLowerCase();
      var question_id = parseInt( field_name.replace( /^q/, '' ), 10 );

      // Only process q{id} named fields
      if ( isNaN( question_id ) ) return;

      // File — async: read to base64 before submitting
      if ( input_type === 'file' ) {
        var file = this.files[0];
        if ( file ) {
          var promise = file_to_base64( file ).then( function (base64) {
            fields.push({
              question_id: question_id,
              file_name:   file.name,
              file_data:   base64,
            });
          });
          file_promises.push( promise );
        }
        return;
      }

      // Checkbox — only include when checked
      if ( input_type === 'checkbox' ) {
        if ( $el.is( ':checked' ) ) {
          fields.push({ question_id: question_id, value: $el.val() });
        }
        return;
      }

      // Radio — skip unchecked options
      if ( input_type === 'radio' && ! $el.is( ':checked' ) ) return;

      fields.push({ question_id: question_id, value: $el.val() });
    });

    // Wait for all file reads, then fire reCAPTCHA + AJAX
    Promise.all( file_promises ).then( function () {
      set_loading( true );

      if ( typeof grecaptcha !== 'undefined' && site_key ) {
        grecaptcha.ready( function () {
          grecaptcha.execute( site_key, { action: 'submit' } ).then( function (token) {
            send_ajax( fields, token );
          });
        });
      } else {
        // No reCAPTCHA configured — submit without token
        send_ajax( fields, '' );
      }
    });
  }


  // ---- AJAX ----

  function send_ajax( fields, recaptcha_token ) {
    $.ajax({
      url:  atreemoFormData.ajaxurl,
      type: 'POST',
      data: {
        action:          'atreemo_form_submit',
        nonce:           atreemoFormData.nonce,
        op_code:         atreemoFormData.opcode,
        recaptcha_token: recaptcha_token,
        fields:          JSON.stringify( fields ),
      },
      success: function (response) {
        set_loading( false );
        if ( response.success ) {
          show_success();
        } else {
          show_error( response.data && response.data.message );
        }
      },
      error: function () {
        set_loading( false );
        show_error();
      },
    });
  }


  // ---- Helpers ----

  function file_to_base64( file ) {
    return new Promise( function (resolve, reject) {
      var reader    = new FileReader();
      reader.onload = function () {
        // Strip the "data:...;base64," prefix — Atreemo wants the raw string
        var base64 = reader.result.split( ',' )[1];
        resolve( base64 );
      };
      reader.onerror = reject;
      reader.readAsDataURL( file );
    });
  }

  function set_loading( is_loading ) {
    $submit_btn.prop( 'disabled', is_loading );
    $submit_btn.text( is_loading ? msg_submitting : submit_label );
  }

  function show_success() {
    $form.hide();
    $success_el.prop( 'hidden', false );
    $( 'html, body' ).animate({ scrollTop: $success_el.offset().top - 100 }, 300 );
  }

  function show_error( message ) {
    var msg = message || msg_error_default;
    $error_container.text( msg ).prop( 'hidden', false );
    $( 'html, body' ).animate({ scrollTop: $error_container.offset().top - 100 }, 300 );
  }

})(jQuery);
